const HEX = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i;

function parse(hex) {
    const m = HEX.exec((hex || "").trim());
    if (!m) return null;
    let value = m[1];
    if (value.length === 3) {
        value = value.replace(/./g, (c) => c + c);
    }
    const n = parseInt(value, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

export function alpha(hex, a) {
    const rgb = parse(hex);
    if (!rgb) return hex;
    return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${a})`;
}

// Mezcla lineal: `weight` es la proporción de hexA (0..1); el resto es hexB.
export function mix(hexA, hexB, weight) {
    const a = parse(hexA);
    const b = parse(hexB);
    if (!a || !b) return hexA;
    return (
        "#" +
        a
            .map((v, i) =>
                Math.round(v * weight + b[i] * (1 - weight))
                    .toString(16)
                    .padStart(2, "0")
            )
            .join("")
    );
}
export const isHexColor = (value) =>
    typeof value === "string" && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value);

const hexToRgb = (hex) => {
    const normalized =
        hex.length === 4
            ? `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`
            : hex;
    const int = parseInt(normalized.slice(1), 16);
    return [(int >> 16) & 255, (int >> 8) & 255, int & 255];
};

export const luminance = (hex) => {
    const [r, g, b] = hexToRgb(hex).map((channel) => {
        const c = channel / 255;
        return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
